import { CustodianActivityStates } from '@generated/graphql';
import { ACTIVITIES_ANY_FILTER } from './activities.config';

export type ActivitiesFilterValues = {
  state: CustodianActivityStates;
  transactionType: string;
  agingFilter: string;
  search: string;
};

export const ACTIVITIES_DEFAULT_FILTER_VALUES: ActivitiesFilterValues = {
  state: CustodianActivityStates.Created,
  transactionType: ACTIVITIES_ANY_FILTER,
  agingFilter: ACTIVITIES_ANY_FILTER,
  search: '',
};

export const hasActivitiesActiveFilters = (
  filters: ActivitiesFilterValues,
): boolean =>
  filters.state !== ACTIVITIES_DEFAULT_FILTER_VALUES.state ||
  filters.transactionType !==
    ACTIVITIES_DEFAULT_FILTER_VALUES.transactionType ||
  filters.agingFilter !== ACTIVITIES_DEFAULT_FILTER_VALUES.agingFilter ||
  filters.search.trim() !== ACTIVITIES_DEFAULT_FILTER_VALUES.search;
